export default [
  {
    id: 1,
    roadmap_stage_title: 'Learn about your industries',
    module: {
      title: 'Session Module Name',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel auctor quam. Phasellus et tortor rutrum lorem dignissim facilisis eu in lorem.',
      industry: 'Industry Name',
      related_skills: [
        'Creative Problem Solving', 'Self-Awareness'
      ]
    },
    advisor: {
      name: 'Name of Advisor',
      image: 'http://placehold.it/150x150',
      job_position: 'Company and Job Title',
      previous_job_positions: [
        'Old Job 1', 'Old Job Two'
      ]
    }
  },
  {
    id: 2,
    roadmap_stage_title: 'Learn about your industries',
    module: {
      title: 'Session Module Name',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel auctor quam. Phasellus et tortor rutrum lorem dignissim facilisis eu in lorem.',
      industry: 'Industry Name',
      related_skills: [
        'Creative Problem Solving', 'Self-Awareness'
      ]
    },
    advisor: {
      name: 'Name of Advisor',
      image: 'http://placehold.it/150x150',
      job_position: 'Company and Job Title',
      previous_job_positions: [
        'Old Job 1', 'Old Job Two'
      ]
    }
  },
  {
    id: 3,
    roadmap_stage_title: 'Learn about your industries',
    module: {
      title: 'Session Module Name',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel auctor quam. Phasellus et tortor rutrum lorem dignissim facilisis eu in lorem.',
      industry: 'Industry Name',
      related_skills: [
        'Creative Problem Solving', 'Self-Awareness'
      ]
    },
    advisor: {
      name: 'Name of Advisor',
      image: 'http://placehold.it/150x150',
      job_position: 'Company and Job Title',
      previous_job_positions: [
        'Old Job 1', 'Old Job Two'
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/LearningRoadmap/dummy-data.js